import { DealRecord } from "@/models/deal";
import { Entity } from "@/orm/types";
import { modals } from "@mantine/modals";
import { CreateFinancialDeckModal } from "./CreateFinancialDeckModal";

export const openCreateFinancialDeckModal = (
  dealEntity?: Entity<DealRecord>,
) => {
  modals.open({
    title: undefined,
    withCloseButton: false,
    centered: true,
    size: "lg",
    children: <CreateFinancialDeckModal dealEntity={dealEntity} />,
  });
};
